export const getKey = (obj) => Object.keys(obj)[0];
